import React, { useEffect, useState } from "react";
import Loader from "../global/Loader";
import DataTable from "../datatable/DataTable";
import { deposits } from "../../constants/data";
import CurrencyFormatter from "../global/CurrencyFormatter";
import DateTimeFormat from "../global/DateTimeFormat";
import { deposit_commissions } from "../../constants/Tariffs";
import SelectInput from "../global/SelectInput";
import Button from "../global/Button";

function DepositsReport() {
  const headers = [
    "Transaction ID",
    "Client",
    "Client ID",
    "Amount",
    "Commission",
    "Date",
  ];
  let tableRows = [];
  let commission = 0;

  if (deposits?.length) {
    for (let i = 0; i < deposits.length; i++) {
      let commissionEarned = deposit_commissions(deposits[i].amount);
      commission = commission += commissionEarned;
      tableRows.push({
        transaction_id: deposits[i].transaction_id,
        client_name: deposits[i].client_name,
        client_id: deposits[i].client_id_number,
        amount: <CurrencyFormatter value={deposits[i].amount} />,
        commission: <CurrencyFormatter value={commissionEarned} />,
        created_at: <DateTimeFormat>{deposits[i].created_at}</DateTimeFormat>,
      });
    }
  }

  const displayContent = deposits ? (
    !deposits.length ? (
      <Loader />
    ) : (
      <DataTable headers={headers} data={tableRows} />
    )
  ) : (
    <Loader />
  );

  const [selectedFrequency, setSelectedFrequency] = useState(1);

  useEffect(() => {
    handleAction(selectedFrequency);
  }, [selectedFrequency]);

  let handleAction = (val) => {
    console.log(val);
  };

  const options = [
    { label: "Daily", value: 1 },
    { label: "Weekly", value: 2 },
    { label: "Monthly", value: 3 },
  ];

  const handleChange = (e) => {
    const val = e.target.value;
    setSelectedFrequency(val);
    handleAction(val);
  };

  return (
    <div>
      {/* header information */}
      <div className="flex sm:flex-col justify-between items-center mb-2">
        <div className="w-40 sm:w-full mt-3">
          <SelectInput
            label="Select frequency"
            onChange={handleChange}
            options={options}
            name="switch_frequency"
            value={selectedFrequency}
          />
        </div>
        <div className="flex items-center justify-end">
          <Button text={"Export Excel"} />
          <Button text={"Export PDF"} bgColor={"bg-red-500"} />
        </div>
      </div>

      {displayContent}
    </div>
  );
}

export default DepositsReport;
